import {
  IApplyOptionsCommonSearchParam,
  IQueueStatusTableReport,
} from "../../../Interfaces/applyOption";
import { getQueueStatusTable } from "../../../Requests/applyOption";
import { CommonTableUI } from "../../TableTemplate/common";
import TableTemplate from "../../TableTemplate/tableTemplate";
import { Additional } from "./Additional";

interface IProps {}

const QueueStatusTable = ({}: IProps) => {
  return (
    <TableTemplate<IApplyOptionsCommonSearchParam, IQueueStatusTableReport>
      TableUI={({ reports, onAction, setSortingType, sortingType }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          setSortingType={setSortingType}
          sortingType={sortingType}
          tableBoxClassName="max-h-[500px] overflow-auto"
          AdditionalBody={Additional}
        />
      )}
      getDataTable={getQueueStatusTable}
      withSort
    />
  );
};

export default QueueStatusTable;
